<template>
  <div>
    <List
      url="getPartnerList"
      deleteUrl="deletePartner"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealGrade"
      :data="searchData"
      :isAdd="true"
      @add="add"
      @edit="edit"
      :operat="operat">
      <div slot="Filter">
        <el-input v-model="searchData.Key" placeholder="Company Name/Sales Representative" style="width:400px;"></el-input>
        <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
        <el-button @click="specialRecommendation"    type="primary" style="margin-left:10px;">Special Recommendation</el-button>
      </div>
    </List>
    <UpdateBox
      :updateType="updateType"
      :initForm="updateForm"
      :type="type"
      v-if="updateBlock"
      @close="updateBlock = false"
      @update="updateList++"
    ></UpdateBox>
    <SpecialRecommendation v-if="specialRecommendationBlock" @close="specialRecommendationBlock = false" ></SpecialRecommendation>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import { PARTNERGRADE } from "@/components/Partner/data.js";
import UpdateBox from "../components/Partner/UpdateBox.vue";
import SpecialRecommendation from "../components/Partner/SpecialRecommendation.vue";
export default {
    components: {
        List,
        UpdateBox,
        SpecialRecommendation
    },
    data() {
        return {
            tanle: [
                { name: "CompanyName", label: "Company Name", width:'250px' },
                { name: "FullName", label: "Full Name" },
                { name: "Email", label: "Email" },
                { name: "GradeName", label: "Grade" },
                { name: "accountFullName", label: "Sales Representative", type: 1, width:'250px' },
                /*  { name: "CompanyWebsite", label: "Company Website" },
                { name: "CompanyDescription", label: "Company Description" },
                { name: "Country", label: "Country" },
                { name: "City", label: "City" }, */
                /*   { name: "Phone", label: "Phone" }, */
                { name: "CreatedTime", label: "Created Time" }
            ],
            searchData: { Key: "" },
            updateList: 0,
            updateType: "add",
            type: "",
            updateForm: {},
            updateBlock: false,
            specialRecommendationBlock: false,
            operat: [{
                text: "Delete",
                eventName: "delete",
                type: "danger",
                PretreatMethod: "confirmDelete"
            },{
                text:"Edit",
                eventName:"edit",
                type:'primary',
                method (data) {
                    return (data.Status !== "1");
                } 
            }]
        };
    },
    mounted() {},
    methods: {
        dealGrade (data) {
            for(let i in data) {
                data[i].GradeName = PARTNERGRADE[data[i].Grade];
                data[i].FullName = data[i].FirstName + " " + data[i].LastName;
            }
            return data;
        },
        add () {
            this.updateForm = {
                CompanyName:"",
                FirstName:"",
                LastName:"",
                Email:"",
                Password:"",
                ConfirmPassword:"",
                CompanyWebsite:"",
                CompanyDescription:"",
                Country:"",
                City:"",
                Phone:"",
                Grade:"0",
                Account:"",
                ACIA:"",
                ACIE:"",
                ACIP:"",
                Partner:"",
                OpenOrder:"0"
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit (val) {
            val.Account = val.AccountID;
            val.Partner = val.PartnerID;
            this.updateForm = val;
            this.updateType = "edit";
            this.updateBlock = true;
            this.type = localStorage.getItem("type");
        },
        specialRecommendation () {
            this.specialRecommendationBlock = true;
        }
    },
    computed: {},
    watch:{}
};
</script>
